export function withoutLocale(path: string): string {
  return path.replace(/^\/[a-z]{2}(-[A-Za-z]{2})?(?=\/|$)/, "") || "/";
}

export function samePageHash(
  href: string | null,
  currentPath: string,
): string | null {
  if (!href?.includes("#")) return null;
  const [path, hash] = href.split("#");
  if (!hash) return null;
  if (path && withoutLocale(path) !== withoutLocale(currentPath)) return null;
  return hash;
}
